// Vite ne résout pas les require() dynamiques : les images de la lib choisies à l'exécution
// passent par ces imports statiques.
import etablissements from "@lde/core_lde_vue/dist/assets/media/etablissements/index.js";
import noImgFourniture from "@lde/core_lde_vue/dist/assets/media/missing_img/no_img_fourniture.svg";
import noImgImage from "@lde/core_lde_vue/dist/assets/media/missing_img/no_img_image.svg";
import noImgNumerique from "@lde/core_lde_vue/dist/assets/media/missing_img/no_img_numerique.svg";
import noImgPapier from "@lde/core_lde_vue/dist/assets/media/missing_img/no_img_papier.svg";

const noImgs = {
  fourniture: noImgFourniture,
  image: noImgImage,
  numerique: noImgNumerique,
  papier: noImgPapier,
};

/**
 * @param {String} type "fourniture", "image", "numerique" ou "papier".
 * @returns {String} URL de l'image par défaut d'un produit sans visuel.
 */
export const getNoImg = (type) => noImgs[type];

/**
 * @param {String} fichier Image de la bibliothèque choisie par l'établissement (ex : "college.svg").
 * @returns {String} URL de l'image.
 */
export const getEtablissementImg = (fichier) => etablissements[fichier];
